import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const call = async (method, endpoint, data = null) => {
    setLoading(true);
    setError(null);
    
    try {
      const config = {
        method,
        url: `${API}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      
      if (data) {
        config.data = data;
      }
      
      const response = await axios(config);
      setLoading(false);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.detail || err.message || 'An error occurred';
      setError(errorMessage);
      setLoading(false);
      throw new Error(errorMessage);
    }
  };

  const get = (endpoint) => call('GET', endpoint);
  const post = (endpoint, data) => call('POST', endpoint, data);
  const put = (endpoint, data) => call('PUT', endpoint, data);
  const del = (endpoint) => call('DELETE', endpoint);

  return {
    loading,
    error,
    get,
    post,
    put,
    delete: del,
  };
};

// Specific API functions
export const contactApi = {
  create: async (contactData) => {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  },
  
  getAll: async () => {
    const response = await axios.get(`${API}/contacts`);
    return response.data;
  }
};

export const companyApi = {
  getInfo: async () => {
    const response = await axios.get(`${API}/company-info`);
    return response.data;
  }
};

export const analyticsApi = {
  get: async () => {
    const response = await axios.get(`${API}/analytics`);
    return response.data;
  },
  
  trackClick: async (clickType) => {
    const response = await axios.post(`${API}/track-click?click_type=${clickType}`);
    return response.data;
  }
};